import { useAuth } from '@/legacy/redux';

// Note these 'hooks' are not react hooks, they are just functions that return a boolean
// Using a proper 'hook' was causing issues with react router

// Which roles exist comes from the environment's AUTH_ROLES; these are the roles the portal checks for.
export const ADMIN_ROLES = ["owner", "superadmin", "timesheet-admin"];
export const SUPER_ADMIN = ["superadmin"];
export const PROJECT_ROLES = ["project-reader", "project-writer", "project-technical"];

const useRoles = () => {
  const { user } = useAuth();
  return user?.roles ?? [];
};

const authorise = (role: string | string[]) => {
  const userRoles = useRoles();
  const roles = Array.isArray(role) ? role : [role];
  return roles.some(role => userRoles.includes(role));
};

export const useIsSuperAdmin = () => {
  return authorise(["superadmin"]);
};

export const useIsAdmin = () => {
  return authorise(ADMIN_ROLES);
};

export const useIsOwner = () => {
  return authorise(["owner"]);
};

export const useIsProjectWriter = () => {
  return authorise(["project-writer"]);
};

export const useIsProjectTechnicalWriter = () => {
  return authorise(["project-writer", "project-technical"]);
}

export const useHasRole = (role: string | string[]) => {
  return authorise(role)
};

export const useAuthorise = () => {
  return (role: string | string[]) => authorise(role)
};
